import { LayoutHOC } from 'base/ui/layout/layout';
import createReceiveSchedule from '.';
import { IPurchaseOrderServices } from 'services/Main/purchaseOrder_services';

export const createReceiveSchedulePage = (layoutHOC: LayoutHOC, services: IPurchaseOrderServices) => {
    return layoutHOC(createReceiveSchedule(services));
};
